/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
    Box,
    StickyBottomHelperNew as StickyBottomHelper,
    AvailabilityTypes,
} from 'sarsaparilla';
import { LayoutControlContext } from './DetailedAvailabilityPageLayout';

export default function DetailedAvailabilityActions({ children }) {
    const { isMobileApp } = useContext(LayoutControlContext);

    return (
        <StickyBottomHelper>
            <Box className="per-availability-book-now">
                <Box
                    className={cx('per-availability-book-now-content', {
                        'mobile-app': isMobileApp,
                    })}
                >
                    {React.Children.map(children, (child) => {
                        if (
                            React.isValidElement(child) &&
                            child.type === AvailabilityTypes &&
                            isMobileApp
                        ) {
                            return null;
                        }
                        return child;
                    })}
                </Box>
            </Box>
        </StickyBottomHelper>
    );
}

DetailedAvailabilityActions.propTypes = {
    children: PropTypes.node,
};
